import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {User} from '../../shared/models';
import {AbstractCRUD, CRUDService, ExceptionService, UtilsService} from '../../xform-compat';
import {SimplePaginatedEventsQueryResource} from '../../shared/models/resources/simplePaginatedEventsQueryResource.model';
import {SimpleEventsEmailResource} from '../../shared/models/resources/simpleEventsEmailResource.model';
import {SimpleSavedQueryResource} from '../../shared/models/resources/simpleSavedQueryResource.model';


@Injectable()
export class CoreService extends AbstractCRUD<User> implements CRUDService<User> {
// export class CoreService {

    constructor(
        // private http: HttpClient,
        exceptionService: ExceptionService,
        http: HttpClient,
        utilsService: UtilsService,
    ) {
        super(exceptionService, http, utilsService);
    }

    public getResourcePath() {
        // return '/api/core/service';
        return '/cci/service';
    }

    public getRequest(apiUrl: string, options?: object) {
        // return this.http.get(apiUrl)
        return this.getHTTP().get(apiUrl, options);
    }

    public postRequest(apiUrl: string, body: object, options?: object) {
        // return this.http.post(apiUrl, body)
        return this.getHTTP().post(apiUrl, body, options);
    }

    public testOauthUserPath() {
        // return this.getResourcePath().concat('/oauth-user-test');
        return super.getApiPath().concat('/oauth-user-test');
    }

    public testOauthCalendarPath() {
        // return this.getResourcePath().concat('/oauth-calendar-test');
        return super.getApiPath().concat('/oauth-calendar-test');
    }

    public eventsQueryPath() {
        return super.getApiPath().concat('/events-query');
    }

    public eventsEmailPath() {
        return super.getApiPath().concat('/events-email');
    }

    public savedQueriesPath() {
        return super.getApiPath().concat('/saved-queries');
    }

    public testOauthUser() {
        const headers = new HttpHeaders();
        const options = {headers: headers};
        return this.postRequest(this.testOauthUserPath(), null, options);
    }

    public getLoggedUser() {
        const headers = new HttpHeaders();
        const options = {headers: headers};
        return this.getRequest(super.getApiPath().concat('/users/me'), options);
    }

    public eventsQuery(simplePaginatedEventsQueryResource: SimplePaginatedEventsQueryResource) {
        const headers = new HttpHeaders();
        const options = {headers: headers};
        return this.postRequest(this.eventsQueryPath(), simplePaginatedEventsQueryResource, options);
    }

    public eventsEmail(simpleEventsEmailResource: SimpleEventsEmailResource) {
        const headers = new HttpHeaders();
        const options = {headers: headers};
        return this.postRequest(this.eventsEmailPath(), simpleEventsEmailResource, options);
    }

    public getSavedQueries() {
        const headers = new HttpHeaders();
        const options = {headers: headers};
        return this.getRequest(this.savedQueriesPath(), options);
    }

    public postSavedQueries(savedQueryResources: SimpleSavedQueryResource[]) {
        const headers = new HttpHeaders();
        const options = {headers: headers};
        return this.postRequest(this.savedQueriesPath(), savedQueryResources, options);
    }

}
